// extracted by mini-css-extract-plugin
export default {"wrapper":"Yz-z","response":"Zz-z","error":"_z-z","disabled":"aA-z","buttons":"bA-z","feedbackQuestionSection":"cA-z","yesNoWrapper":"dA-z"};